import { useRouter } from "next/router";
import { useEffect, useMemo, useRef } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  addFavorites,
  deleteFavorites,
  fetchFavorites,
} from "../../../api/favorites";
import { failAlert, successAlert } from "../../../common/alert";
import { priceComma } from "../../../common/splicePrice";
import {
  addToCart,
  decreaseCnt,
  increaseCnt,
} from "../../../redux/action/cart";
import ProductTab from "./ProductTab";
import RelatedSlider from "../../sliders/Related";
import ThumbSlider from "../../sliders/Thumb";
import Seo from "../../layout/Seo";
import {
  insertBasketsAction,
  fetchBasketsAction,
} from "../../../redux/action/baskets";
import { getCookie } from "../../../common/auth";
import * as Detail from "./ProductDetails-styles";
import {
  hashSetProducts,
  inquirySet,
  ProductsApi,
} from "../../../api/products";
import ProductInquiryModal from "./inquiryModal";
import InquiryCompleteModal from "../../elements/inquiryCompleteModal";
import RequestLoginModal from "../../elements/requestLoginModal";
import PaymentNaverPay from "../../payment/Naverpay";
import * as gtag from "../../../lib/gtag";
import { isLoaded, isLoading } from "../../../redux/action/loading";
import { SfnzBadge } from "../../ecommerce/singleProduct/SingleProduct-styles";
import { insertVP } from "../../../redux/action/userView";
import CouponModal from "../../mypage/coupon/couponModal";
import TableTypeList from "../list/TableTypeList";
import Filter from "../../../common/filter/filter";
import Link from "next/link";
import { calcProdPoint } from "../../../common/helper";
import { H1Font } from "@style/fontStyle";
import { SubBtn } from "./ProductDetails-styles";
import { closeQuickView } from "@redux/action/quickViewAction";
import CategorySlider from "@components/sliders/Category";
import Layout from "@components/layout/Layout";
import { SITE_URL } from "@api/constants/resources";
import Head from "next/head";
import useUserInfo from "@hook/app/useUserInfo";

const ProductsDetail = (props) => {
  const {
    product,
    quickView,
    cartItems,
    addToCart,
    insertBasketsAction,
    basketsItems,
    userDevice,
    isLoading,
    isLoaded,
    dummyList,
    insertVP,
    loading,
    userInfo,
    vp,
    seoData,
  } = props;

  const generateProductSchema = () => {
    if (!product) return null;

    const productName = product?.pname;
    const productUrl = `${SITE_URL}/products/${product.ename}/${product.pcode}/`;

    return {
      "@context": "https://schema.org",
      "@type": "Product",
      name: productName,
      image: product.main_image,
      description: product.comment,
      category: [
        product.category_code,
        product.category_tag?.[0],
      ].filter(Boolean).join(" > "),
      sku: product.pcode,
      brand: {
        "@type": "Brand",
        name: product.brand_kor || "칼렛바이오",
      },
      offers: {
        "@type": "Offer",
        url: productUrl,
        priceCurrency: "KRW",
        price: Number(
          String(product.discount_price || 0).replace(/,/g, "")
        ),
        itemCondition: "https://schema.org/NewCondition",
        availability:
          product.sold_out === "Y"
            ? "https://schema.org/OutOfStock"
            : "https://schema.org/InStock",
              },
    };
  };

  const router = useRouter();
  const [cnt, setCnt] = useState(1);
  const [isAddedWish, setIsAddedWish] = useState(false);
  const [related, setRelated] = useState([]);
  const [mouseOn, setMouseOn] = useState([false, false]);
  const [openInquiryModal, setOpenInquiryModal] = useState(false);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [couponModal, setCouponModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const tabRef = useRef(null);
  const [brandProducts, setBrandProducts] = useState(null);
  const filterRef = useRef(null);

  // orderType이 'O' 이거나 값이 없으면 기존 구매 UI 노출
  const isOrderTypeO = !product.orderType || product.orderType === "O";

  // fetch brandproducts
  const fetchBrandProducts = async (code) => {
    try {
      const body = {
        modes: "BrandList",
        code,
      };
      const res = await ProductsApi(body);

      if (res?.Code === "0000") {
        setBrandProducts(res?.Data?.Rows);
      }
    } catch (error) {
      console.error(error?.message);
    }
  };

  const handleActiveTab = (idx) => {
    window.scrollTo({
      behavior: "instant",
      left: 0,
      top: tabRef.current.offsetTop,
    });
    setActiveTab(idx);
  };

  // 카테고리 필터 클릭 및 스크롤 핸들러
  const handleCategoryFilter = () => {
    if (filterRef.current) {
      filterRef.current.handleFilterClick("reset");
    }

    if (activeTab === 1 || activeTab === 2) {
      setActiveTab(0);
    }

    setTimeout(() => {
      const targetTab = product?.brand ? 2 : 1;
      handleActiveTab(targetTab);

      if (filterRef.current) {
        filterRef.current.setCategory(product.category_code);
      }

      const filterElement = document.querySelector(".filter-section");
      if (filterElement) {
        filterElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const userCoupon = useMemo(() => {
    if (userInfo?.Coupon) {
      return userInfo?.Coupon?.rows;
    } else {
      return null;
    }
  }, [userInfo]);

  // 장바구니 담기
  const handleCart = async (product) => {
    const item = {
      ...product,
      cnt: Math.max(1, Number(cnt) || 1),
    };

    if (item) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_name: item?.pname,
              item_id: item.pcode,
              price: item.price,
              item_brand: item.supplier,
              item_category:
                item.category_code.length > 2
                  ? item.category_code
                  : dummyList?.category[item.category_code],
              quantity: item.cnt,
            },
          ],
        },
      });
      window.ChannelIO("track", "AddToCart", { pcode: item.pcode });
    }

    if (!getCookie("token")) {
      return addToCart(item);
    } else {
      return insertBasketsAction(item, item.cnt);
    }
  };

  // 장바구니 담긴 상태 확인
  const inCart = !getCookie("token")
    ? cartItems?.find((cartItem) => cartItem.pcode === product.pcode)
    : basketsItems?.find((basketsItem) => basketsItem.pcode === product.pcode);

  // 위시리스트 리스트
  const fetchWishList = async (product) => {
    const body = {
      modes: "ListSet",
    };
    const data = await fetchFavorites(body);
    if (data?.data?.find((el) => el.pcode === product.pcode))
      setIsAddedWish(true);
  };

  // 위시리스트 등록
  const handleWishlist = async (product) => {
    const body = {
      modes: "InsertSet",
      pcode: product.pcode,
    };
    const data = await addFavorites(body);
    if (data?.code === "0000") {
      setIsAddedWish(true);
      successAlert("위시리스트에 등록되었습니다");
      if (product) {
        window.ChannelIO("track", "AddToWish", {
          pcode: product.pcode,
        });
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "add_to_wishlist",
          ecommerce: {
            items: [
              {
                item_name: product?.pname,
                item_id: product.pcode,
                price: product.price,
                item_brand: product.supplier,
                item_category: product.category_code,
              },
            ],
          },
        });
      }
    }
    if (data?.code === "9999" && data?.msg === "토큰 정보 조회 실패")
      return router.push("/login");
    if (data?.code === "9999") return failAlert(data?.msg);
  };

  // 위시리스트 삭제
  const deleteWishlist = async (product) => {
    const body = {
      modes: "DeleteSet",
      pcode: product.pcode,
    };
    const data = await deleteFavorites(body);
    if (data?.code === "0000") {
      setIsAddedWish(false);
      successAlert("위시리스트에서 삭제되었습니다");
    }
    if (data?.code === "9999") return failAlert(data.msg);
  };

  // 이미 담긴 상품 장바구니 버튼 클릭 시 툴팁
  const handleCartBtn = () => {
    if (!mouseOn[0]) {
      setMouseOn([true, false]);
    }
  };

  // 비회원 바로 구매 모달 오픈
  const handleLoginModal = () => {
    setOpenLoginModal((prev) => !prev);
  };

  // 바로 구매하기
  const purchaseDirect = (product) => () => {
    if (!getCookie("token") && !openLoginModal) {
      handleLoginModal();
      return;
    } else {
      sessionStorage.setItem(
        "directOrder",
        JSON.stringify([{ ...product, cnt: cnt }])
      );
      router.push({
        pathname: "/checkout",
        query: {
          type: "direct",
        },
      });
    }
  };

  // 관련 상품
  const fetchRelatedProducts = async () => {
    setCnt(1);

    const body2 = {
      modes: "HashSet",
      code: dummyList.category?.find((el) => el.name === product.category_code)
        ?.code,
      hash: product.category_tag?.length > 0 && product.category_tag[0],
    };

    const res = await hashSetProducts(body2);

    setRelated(res.Data?.Rows.slice(0, 20));
  };

  // 제작 문의
  const onClickInquiry = () => {
    if (!openInquiryModal && userInfo?.Member) {
      const m = userInfo.Member;

      setInquiryInputs({
        name: m.name ?? "",
        tel: m.phone ?? m.tel ?? "",
        email: m.email ?? m.id ?? "",
        company: m.company ?? "",
      });
    }

    setOpenInquiryModal((prev) => !prev);
  };

  const [inquiryInputs, setInquiryInputs] = useState({});

  const onChangeInquiry = (id) => (e) => {
    if (id.includes("file")) {
      setInquiryInputs({ ...inquiryInputs, [id]: e.target.files[0] });
      return;
    }
    setInquiryInputs({ ...inquiryInputs, [id]: e.target.value });
  };

  // 문의 완료
  const [openInquiryComplete, setOpenInquiryComplete] = useState(false);

  const onClickInquiryComplete = () => {
    setOpenInquiryComplete((prev) => !prev);
  };

  // 제작 문의 등록
  const submitInquiry = async () => {
    if (
      !inquiryInputs.division ||
      !inquiryInputs.name ||
      !inquiryInputs.tel ||
      !inquiryInputs.email
    ) {
      failAlert("필수 항목을 입력해주세요.");
      return;
    }
    if (
      !inquiryInputs.tel.match(
        /^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/
      )
    ) {
      failAlert("사용가능한 전화번호를 입력해주세요.");
      return;
    }
    isLoading();
    const body = {
      modes: "InquirySet",
      pcode: product.pcode,
      ...inquiryInputs,
    };
    const res = await inquirySet(body);
    if (res.Code === "0000") {
      onClickInquiryComplete();
      onClickInquiry();
      setInquiryInputs({});
      isLoaded();
    } else {
      failAlert("문의 등록에 실패했습니다.");
      isLoaded();
    }
  };

  // ename을 찾는 함수 추가
  const findCategoryEname = () => {
    if (!dummyList || !dummyList.category) return "";

    const category = dummyList.category.find(
      (cat) =>
        cat.code === product.category_code || cat.name === product.category_code
    );

    return category ? category.ename : "";
  };

  useEffect(() => {
    if (!dummyList) return;
    if (product?.brand) {
      fetchBrandProducts(product.brand);
    }
    if (product.pcode) {
      fetchWishList(product);
      fetchRelatedProducts();
      const ename = findCategoryEname();

      const vp = JSON.parse(sessionStorage.getItem("vp"));
      if (!vp) {
        sessionStorage.setItem(
          "vp",
          JSON.stringify([
            {
              pname: product.pname,
              pcode: product.pcode,
              discount_price: product.discount_price,
              main_image: product.main_image,
              ename: ename,
            },
          ])
        );
        insertVP([
          {
            pname: product.pname,
            pcode: product.pcode,
            discount_price: product.discount_price,
            main_image: product.main_image,
            ename: ename,
          },
        ]);
      } else if (vp.find((el) => el.pcode === product.pcode)) {
        const idx = vp.findIndex((el) => el.pcode === product.pcode);
        vp.splice(idx, 1);
        sessionStorage.setItem(
          "vp",
          JSON.stringify([
            {
              pname: product.pname,
              pcode: product.pcode,
              discount_price: product.discount_price,
              main_image: product.main_image,
              ename: ename,
            },
            ...vp,
          ])
        );
        insertVP([
          {
            pname: product.pname,
            pcode: product.pcode,
            discount_price: product.discount_price,
            main_image: product.main_image,
            ename: ename,
          },
          ...vp,
        ]);
      } else {
        sessionStorage.setItem(
          "vp",
          JSON.stringify([
            {
              pname: product.pname,
              pcode: product.pcode,
              discount_price: product.discount_price,
              main_image: product.main_image,
              ename: ename,
            },
            ...vp,
          ])
        );
        insertVP([
          {
            pname: product.pname,
            pcode: product.pcode,
            discount_price: product.discount_price,
            main_image: product.main_image,
            ename: ename,
          },
          ...vp,
        ]);
      }
    }

    const adnTracker = () => {
      if (window.fn_across_adn_contain) {
        try {
          var across_adn_item_contain = new fn_across_adn_contain();
          var across_adn_item_param = [];
          across_adn_item_param = {
            ut: "Item",
            ui: "108274",
            items: { i: product.pcode, s: "" },
          };
          across_adn_item_contain.init(across_adn_item_param);
        } catch (error) {
          console.error(error);
        }
      }
    };

    if (product.pcode) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "view_item",
        ecommerce: {
          items: [
            {
              item_name: product.pname,
              item_id: product.pcode,
              price: product.price,
              item_brand: product.supplier,
              item_category: product.category_code,
            },
          ],
        },
      });
      var UserAgent = navigator.userAgent;
      var widerplanet_device =
        UserAgent.match(
          /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
        ) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null
          ? "mobile"
          : "web";
      var wptg_tagscript_vars = globalThis.wptg_tagscript_vars || [];
      wptg_tagscript_vars.push(function () {
        return {
          wp_hcuid: userInfo?.Member?.id || "",
          ti: "54644",
          ty: "Item",
          device: widerplanet_device,
          items: [{ i: product.pcode, t: product.pname }],
        };
      });
      globalThis.wptg_tagscript?.exec();
      adnTracker();
    }
  }, [product, dummyList]);

  useEffect(() => {
    if (!router.isReady) return;

    const handleRouteChange = () => {
      CallMtm();
    };

    window.ENP_VAR = {
      collect: {},
    };
    ENP_VAR.collect.productCode = product.pcode;
    ENP_VAR.collect.productName = product.pname;
    ENP_VAR.collect.price = product.price;
    ENP_VAR.collect.dcPrice = product.discount_price;
    ENP_VAR.collect.soldOut = product.sold_out;
    ENP_VAR.collect.imageUrl = product.main_image;
    ENP_VAR.collect.secondImageUrl =
      (product.sub_image.length > 0 && product.sub_image[0]) || "";
    ENP_VAR.collect.thirdImageUrl =
      (product.sub_image.length > 0 && product.sub_image[1]) || "";
    ENP_VAR.collect.fourthImageUrl =
      (product.sub_image.length > 0 && product.sub_image[2]) || "";
    ENP_VAR.collect.topCategory = product.category_code?.split(",")?.[0];
    ENP_VAR.collect.firstSubCategory = product.category_tag[0];

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.isReady, product, dummyList]);

  const addPrintCart = () => {
    const cartKey = "printCart";
    const currentCart = JSON.parse(sessionStorage.getItem(cartKey)) || [];

    const isAlreadyAdded = currentCart.some((el) => el.pcode === product.pcode);

    if (!isAlreadyAdded) {
      const updatedCart = [{ ...product, cnt: 1 }, ...currentCart];
      sessionStorage.setItem(cartKey, JSON.stringify(updatedCart));
    }

    router.push("/customizing/print/quote/");
  };

  const keywordsString = product.search_tag
    ? product.search_tag.join(", ")
    : "";

  const isValidProduct = (product) => {
    const requiredFields = ["pcode", "ename", "category_code"];
    return requiredFields.every(
      (field) => product[field] !== null && product[field] !== undefined
    );
  };

  const holdTimer = useRef(null);
  const intervalRef = useRef(null);
  const isHoldingRef = useRef(false);
  const isPointerDownRef = useRef(false);

  const HOLD_DELAY = 300;
  const HOLD_SPEED = 60;

  const change = (delta) => {
    setCnt((prev) => Math.max(1, (Number(prev) || 1) + delta));
  };

  const resetCnt = () => {
    setCnt(1);
  };

  const startPress = (delta, e) => {
    e.preventDefault();
    isPointerDownRef.current = true;
    isHoldingRef.current = false;

    holdTimer.current = setTimeout(() => {
      isHoldingRef.current = true;
      intervalRef.current = setInterval(() => change(delta), HOLD_SPEED);
    }, HOLD_DELAY);
  };

  const endPress = (delta) => {
    clearTimeout(holdTimer.current);
    clearInterval(intervalRef.current);

    if (!isHoldingRef.current && isPointerDownRef.current) {
      change(delta);
    }
    isPointerDownRef.current = false;
    isHoldingRef.current = false;
  };

  // 비회원 기준 회원가입 쿠폰 할인 정책
  const getSignUpCouponDiscount = (amount) => {
    if (amount >= 300000) return 30000;
    if (amount >= 100000) return 10000;
    if (amount >= 50000) return 4000;
    if (amount >= 10000) return 2000;
    return 0;
  };

  const totalPrice = (Number(product?.discount_price) || 0) * cnt;
  const signUpCouponDiscount = getSignUpCouponDiscount(totalPrice);
  const finalPriceWithSignUpCoupon = Math.max(
    0,
    totalPrice - signUpCouponDiscount
  );
  const isGuest = !getCookie("token");

  useEffect(
    () => () => {
      clearTimeout(holdTimer.current);
      clearInterval(intervalRef.current);
    },
    []
  );

  // 전화문의
  const handleTelInquiry = () => {
    const tel = "02-6964-6930";
    if (!tel) {
      failAlert("전화번호 정보가 없습니다.");
      return;
    }
    window.location.href = `tel:${tel}`;
  };

  // 채널톡 문의
  const handleChannelTalkInquiry = () => {
    if (typeof window !== "undefined" && window.ChannelIO) {
      window.ChannelIO("show");
    } else {
      failAlert("채널톡 호출이 불가능한 상태입니다.");
    }
  };

  return (
    <>
      <Layout
        parent={"홈"}
        sub={"상품구매"}
        subTitle={product.category_code}
        subChild={product.category_tag[0]}
        detailsubChild={product.pname}
        pageTitle={product.pname}
        pageDesc={product.comment}
        pageImg={product.main_image}
        pageKeyword={keywordsString}
        id={product.ename}
      >
      <Head>
        {/* 판매중지 상품은 Google 색인 제외 */}
        {product?.view !== "Y" && (
          <meta name="robots" content="noindex, follow" />
        )}

        {/* 정상 상품 canonical */}
        {product?.view === "Y" &&
          product?.pcode &&
          product?.ename && (
            <link
              rel="canonical"
              href={`${SITE_URL}/products/${product.ename}/${product.pcode}/`}
            />
          )}

        {/* 정상 상품만 Product 구조화 데이터 출력 */}
        {product &&
          product.view === "Y" &&
          isValidProduct(product) && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(generateProductSchema()),
              }}
            />
          )}
      </Head>
        <div className="quick-view">
          <Detail.Container className="mb-50">
            <div className="container">
              <div className="row">
                <Detail.TopWrapper className="row">
                  <div className="col-md-6 col-sm-12 col-xs-12 mb-md-0 mb-sm-5">
                    <Detail.SliderWrapper>
                      <ThumbSlider product={product} url={props.main_image} />
                      {product.sfnz_view === "Y" && (
                        <SfnzBadge>
                          <img
                            src={
                              "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png"
                            }
                            alt="SFNZ_badge"
                          />
                        </SfnzBadge>
                      )}
                    </Detail.SliderWrapper>
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12 mt-10">
                    {product.view === "N" || product.view === null ? (
                      <div className="title-wrapper">
                        <H1Font>판매 중지되었거나 없는 상품입니다.</H1Font>
                      </div>
                    ) : (
                      <Detail.DetailInfo>
                        <Detail.HeaderWrapper>
                          <div className="title-wrapper">
                            <H1Font>{product.pname}</H1Font>
                            <span>{product.comment}</span>
                          </div>
                          <div className="share-wish-wrapper">
                            {isAddedWish ? (
                              <a
                                aria-label="delete To Wishlist"
                                className="action-btn hover-up"
                                onClick={() => deleteWishlist(product)}
                                style={{
                                  backgroundColor: "#3bb77e",
                                  color: "#fff",
                                  border: "1px solid #3bb77e",
                                }}
                              >
                                <i
                                  className="fi-rs-heart"
                                  style={{ opacity: "1" }}
                                ></i>
                              </a>
                            ) : (
                              <a
                                aria-label="Add To Wishlist"
                                className="action-btn hover-up mobonWish"
                                onClick={() => handleWishlist(product)}
                                style={{
                                  border: "none",
                                }}
                              >
                                <i className="fi-rs-heart"></i>
                              </a>
                            )}

                            <a
                              aria-label="Share"
                              className="action-btn hover-up"
                              style={{
                                border: "none",
                              }}
                              onClick={() =>
                                navigator.clipboard
                                  .writeText(globalThis.location.href)
                                  .then(() => successAlert("복사되었습니다."))
                              }
                            >
                              <i className="fi-rs-share"></i>
                            </a>
                          </div>
                        </Detail.HeaderWrapper>

                        <Detail.CommentWrapper>
                          {product.ment?.find((el) => el !== "") && (
                            <div className="mt-1">
                              <h6> - 상품 정보</h6>
                              <Detail.ProductCommnet>
                                {product.ment
                                  .filter((el) => el !== "")
                                  ?.map((el, i) => (
                                    <li key={i}>{el}</li>
                                  ))}
                              </Detail.ProductCommnet>
                            </div>
                          )}
                        </Detail.CommentWrapper>

                        {/* 🔻 여기부터가 네모칸 영역 – orderType에 따라 분기 */}

                        {isOrderTypeO && (
                          <>
                            <Detail.PriceWrapper>
                              <div className="qty-wrapper">
                                <div className="detail-qty border radius">
                                  <a
                                    className="qty-down"
                                    aria-label="수량 감소"
                                    role="button"
                                    tabIndex={0}
                                    onPointerDown={(e) =>
                                      startPress(-1, e)
                                    }
                                    onPointerUp={() => endPress(-1)}
                                    onPointerLeave={() => endPress(-1)}
                                    onPointerCancel={() => endPress(-1)}
                                  >
                                    <i className="fi-rs-angle-small-down"></i>
                                  </a>

                                  <span className="qty-val">{cnt}</span>

                                  <a
                                    className="qty-up"
                                    aria-label="수량 증가"
                                    role="button"
                                    tabIndex={0}
                                    onPointerDown={(e) =>
                                      startPress(1, e)
                                    }
                                    onPointerUp={() => endPress(1)}
                                    onPointerLeave={() => endPress(1)}
                                    onPointerCancel={() => endPress(1)}
                                  >
                                    <i className="fi-rs-angle-small-up"></i>
                                  </a>
                                </div>
                                <div className="qty-quick-add">
                                  <button type="button" className="quick-btn" onClick={resetCnt}>
                                    초기화
                                  </button>                         
                                  <button type="button" className="quick-btn" onClick={() => change(10)}>
                                    +10
                                  </button>
                                  <button type="button" className="quick-btn" onClick={() => change(100)}>
                                    +100
                                  </button>
                                </div>
                              </div>
                              <div className="price">
                                {product.salePer > 0 && (
                                  <div className="old-price">
                                    <Detail.SalePer>
                                      <span>{product.salePer}%</span>
                                    </Detail.SalePer>
                                    <Detail.OldPrice>
                                      {priceComma(product.price)}원
                                    </Detail.OldPrice>
                                  </div>
                                )}
                                {product?.discount_price && (
                                  <span className="discount_price">
                                    {priceComma(
                                      product?.discount_price
                                    )}
                                    원
                                  </span>
                                )}

                                {Number(product.quantity) > 1 && (
                                  <div className="d-flex justify-content-end">
                                    개당{" "}
                                    {priceComma(
                                      Math.floor(
                                        Number(
                                          product.discount_price
                                        ) / Number(product.quantity)
                                      )
                                    )}
                                    원
                                  </div>
                                )}
                              </div>
                            </Detail.PriceWrapper>

                            <Detail.PriceWrapper totalPrice={true}>
                              <div className="pricebox-top gap-3">
                                <Detail.SubBtn
                                  onClick={handleCategoryFilter}
                                >
                                  {product.category_code} 다른 상품 보기
                                </Detail.SubBtn>
                                <Detail.PointBox>
                                  <span className="d-flex align-items-center">
                                    예상적립금 최대{" "}
                                    {priceComma(
                                      calcProdPoint(
                                        (Number(
                                          String(
                                            product.discount_price
                                          ).replace(/[^\d.-]/g, "")
                                        ) || 0) * cnt
                                      )
                                    )}
                                    <Detail.Sticker>
                                      P
                                    </Detail.Sticker>
                                  </span>
                                  <span className="d-flex align-items-center">
                                    적립
                                    <span
                                      className="infoIcon"
                                      onMouseOver={() =>
                                        setMouseOn([false, true])
                                      }
                                      onMouseLeave={() =>
                                        setMouseOn([false, false])
                                      }
                                    >
                                      ?
                                    </span>
                                  </span>
                                  {mouseOn[1] && (
                                    <Detail.BtnInfo className="info">
                                      포인트는 할인 쿠폰 적용, 옵션가격,
                                      수량을 기준으로 적립되므로 최종
                                      적립 포인트는 쿠폰 사용 여부 및
                                      옵션가격, 수량에 따라 달라질 수
                                      있습니다.
                                    </Detail.BtnInfo>
                                  )}
                                </Detail.PointBox>
                              </div>

                              <div className="pricebox-bottom">
                                <div className="title">최종 금액</div>
                                <div className="price">
                                  {product?.discount_price && (
                                    <Detail.DiscountPrice className="text-brand">
                                      {priceComma(
                                        product?.discount_price * cnt
                                      )}
                                      원
                                    </Detail.DiscountPrice>
                                  )}
                                </div>
                              </div>

                              {isGuest && signUpCouponDiscount > 0 && (
                                <Detail.SignUpCouponBox>
                                  <div className="coupon-row">
                                    <span className="label">
                                      회원가입 쿠폰 적용 시 최종 금액
                                    </span>
                                    <span className="price">
                                      {priceComma(
                                        finalPriceWithSignUpCoupon
                                      )}
                                      원
                                    </span>
                                  </div>
                                  <div className="coupon-desc">
                                    회원가입 시 5만원 쿠폰팩 자동지급
                                    <Link
                                      href="https://www.caretstore.co.kr/register"
                                      legacyBehavior
                                    >
                                      <a>회원가입</a>
                                    </Link>
                                  </div>
                                </Detail.SignUpCouponBox>
                              )}
                            </Detail.PriceWrapper>

                            <Detail.InfoRow>
                              <Detail.DeliveryComment>
                                <li>
                                  <strong>
                                    {product.delivery_type_korea ===
                                    "무료"
                                      ? "무료배송"
                                      : product.delivery_type === "C"
                                      ? "착불 배송"
                                      : "배송료 : " +
                                        product.delivery_type_korea +
                                        " " +
                                        priceComma(
                                          Number(
                                            product?.delivery_price
                                          ) *
                                            (product.bundle === "Y"
                                              ? cnt
                                              : 1)
                                        ) +
                                        "원"}
                                  </strong>
                                </li>
                                {Number(product.deadline) > 0 && (
                                  product.supplier === "C46766" ? (
                                    <li>주 1회(목요일) 순차 발송</li>
                                  ) : (
                                    <li>
                                      <strong>{product.deadline}시</strong>
                                      까지 주문시 당일 발송
                                    </li>
                                  )
                                )}
                              </Detail.DeliveryComment>
                              {product.sold_out === "N" &&
                                product.inquiry === "Y" && (
                                  <Detail.MakeBtnWrapper>
                                    <Detail.CheckoutBtn
                                      onClick={onClickInquiry}
                                      noMargin={true}
                                    >
                                      제작 문의
                                    </Detail.CheckoutBtn>
                                  </Detail.MakeBtnWrapper>
                                )}
                            </Detail.InfoRow>

                            <Detail.BtnWrapper>
                              {product.sold_out === "Y" ? (
                                <Detail.QtyCheckOutBtnWrapper>
                                  <Detail.SoldOut>
                                    품절 상품
                                  </Detail.SoldOut>
                                  <Detail.CheckoutBtn
                                    inquiry={product.inquiry}
                                    onClick={onClickInquiry}
                                  >
                                    제작 문의
                                  </Detail.CheckoutBtn>
                                </Detail.QtyCheckOutBtnWrapper>
                              ) : (
                                <>
                                  <Detail.QtyCheckOutBtnWrapper>
                                    <div className="btnBox">
                                      {!inCart ? (
                                        <Detail.CartBtn
                                          className="mobonCart"
                                          onClick={() => {
                                            handleCart({
                                              ...product,
                                              cnt: cnt || 1,
                                            });
                                            setMouseOn([true, false]);
                                          }}
                                        >
                                          <div className="d-flex align-items-center justify-content-center">
                                            장바구니
                                          </div>
                                        </Detail.CartBtn>
                                      ) : (
                                        <Detail.CartBtn
                                          isStored={true}
                                          onClick={handleCartBtn}
                                        >
                                          <div className="d-flex align-items-center justify-content-center">
                                            장바구니
                                          </div>
                                          {mouseOn[0] && (
                                            <Detail.CartTooltip>
                                              <div className="text-center tooltip-msg">
                                                상품이 장바구니에
                                                담겼습니다.
                                              </div>
                                              <div className="btnWrapper">
                                                <Link href="/shop-cart">
                                                  <button className="btn btn-xs move-cart">
                                                    장바구니 이동
                                                  </button>
                                                </Link>
                                                <button
                                                  className="btn btn-xs keep-shopping"
                                                  onClick={() =>
                                                    setMouseOn([
                                                      false,
                                                      false,
                                                    ])
                                                  }
                                                >
                                                  계속 쇼핑하기
                                                </button>
                                              </div>
                                            </Detail.CartTooltip>
                                          )}
                                        </Detail.CartBtn>
                                      )}

                                      <Detail.CheckoutBtn
                                        onClick={purchaseDirect({
                                          ...product,
                                          cnt: cnt,
                                        })}
                                        inquiry={"Y"}
                                        noMargin={true}
                                      >
                                        바로 구매
                                      </Detail.CheckoutBtn>
                                    </div>
                                  </Detail.QtyCheckOutBtnWrapper>
                                </>
                              )}
                              {product.smallYn === "Y" && product.sold_out !== "Y" && (
                                <button
                                  className="btn print-btn"
                                  onClick={addPrintCart}
                                >
                                  소량인쇄 신청
                                </button>
                              )}
                            </Detail.BtnWrapper>

                            {product.sold_out !== "Y" &&
                              product.delivery_type &&
                              product.delivery_code && (
                                <Detail.SocialPayWrapper>
                                  {product.pcode && (
                                    <PaymentNaverPay
                                      product={product}
                                      cnt={cnt}
                                      userDevice={userDevice}
                                    />
                                  )}
                                </Detail.SocialPayWrapper>
                              )}
                          </>
                        )}

                        {/* ✅ orderType이 O가 아닌 경우: 네모칸 전체 숨기고 문의 버튼만 노출 */}
                        {!isOrderTypeO && (
                          <Detail.BtnWrapper>
                            {product.orderType === "P" && (
                              <button
                                className="btn print-btn"
                                onClick={onClickInquiry}
                              >
                                제작 문의
                              </button>
                            )}
                            {product.orderType === "T" && (
                              <button
                                className="btn print-btn"
                                onClick={handleTelInquiry}
                              >
                                전화 문의
                              </button>
                            )}
                            {product.orderType === "C" && (
                              <button
                                className="btn print-btn"
                                onClick={handleChannelTalkInquiry}
                              >
                                채널톡 문의
                              </button>
                            )}
                          </Detail.BtnWrapper>
                        )}
                      </Detail.DetailInfo>
                    )}
                  </div>
                </Detail.TopWrapper>
                <div className="container">
                  {product.related && product.related.length > 0 && (
                    <div className="row mb-20">
                      <div className="col-12">
                        <h3 className="section-title style-1 mb-30">
                          연관 상품
                        </h3>
                      </div>
                      <div className="col-12">
                        <div className="related-products position-relative">
                          <RelatedSlider
                            related={product.related.map((el) => {
                              return {
                                ...el,
                                pcode: el.plink
                                  .split("products/")[1]
                                  .replace("/", ""),
                              };
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="" ref={tabRef}>
                    {(product?.options?.length > 0 || product?.brand) && (
                      <Detail.ProductDetailTabs>
                        {["상품 상세", "옵션 상품", "브랜드 바로가기"].map(
                          (tab, tabIdx) => {
                            if (
                              tab === "옵션 상품" &&
                              product?.options?.length === 0
                            ) {
                              return;
                            }
                            if (tab === "브랜드 바로가기" && !product?.brand) {
                              return;
                            }
                            return (
                              <Detail.DetailTab
                                active={activeTab === tabIdx}
                                key={tabIdx}
                                onClick={() => handleActiveTab(tabIdx)}
                              >
                                {tab}
                              </Detail.DetailTab>
                            );
                          }
                        )}
                      </Detail.ProductDetailTabs>
                    )}
                    {activeTab === 0 && <ProductTab product={product} />}
                    {(activeTab === 1 || activeTab === 2) && (
                      <Detail.OptionProducts>
                        <Filter
                          dummyList={dummyList}
                          productList={
                            (activeTab === 1 && product?.options) ||
                            (activeTab === 2 && brandProducts)
                          }
                          fixedViewType="list"
                          purchaseDirect={purchaseDirect}
                          handleCart={handleCart}
                          basketsItems={basketsItems}
                          cartItems={cartItems}
                          product={product}
                          ref={filterRef}
                        />
                      </Detail.OptionProducts>
                    )}
                  </div>
                  {product.view !== "N" && product.view !== null && (
                    <div className="row mt-60">
                      <div className="col-12">
                        <h3 className="section-title style-1 mb-30">
                          함께 많이 본 상품
                        </h3>
                      </div>
                      <div className="col-12 ">
                        <div className="related-products position-relative">
                          <RelatedSlider related={related} />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Detail.Container>
          {openInquiryModal && (
            <ProductInquiryModal
              onClickInquiry={onClickInquiry}
              openInquiryModal={openInquiryModal}
              submitInquiry={submitInquiry}
              onChangeInquiry={onChangeInquiry}
              inquiryInputs={inquiryInputs}
            />
          )}
          {openInquiryComplete && (
            <InquiryCompleteModal
              onClickInquiryComplete={onClickInquiryComplete}
            />
          )}
          {openLoginModal && (
            <RequestLoginModal
              handleLoginModal={handleLoginModal}
              openLoginModal={openLoginModal}
              purchaseDirect={purchaseDirect}
              product={product}
              cnt={cnt}
            />
          )}
          {couponModal && (
            <CouponModal
              coupons={userCoupon}
              loading={loading}
              show={couponModal}
              setShow={setCouponModal}
            />
          )}
        </div>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  cartItems: state.cart,
  basketsItems: state.baskets.items,
  basketsCount: state.baskets.count,
  dummyList: state.dummyList,
  vp: state.vp,
  loading: state.loading.loading,
  userInfo: state.userInfo,
  quickView: state.quickView,
});

const mapDispatchToProps = {
  addToCart,
  increaseCnt,
  decreaseCnt,
  insertBasketsAction,
  fetchBasketsAction,
  isLoading,
  isLoaded,
  insertVP,
  closeQuickView,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsDetail);
